<template>
    <div>
        <Hero />

        <div class="p-5 md:p-20">
            <div class="uppercase font-bold text-xl">A people of the word and prayer</div>

            <div class="grid lg:grid-cols-2 mt-5 text-xl items-center gap-y-8">
                <div class="px-2 flex justify-center">
                    <img src="../assets/images/what_we_believe_1.png" class="rounded" alt="">
                </div>
                <div class="px-2">
                    <div>
                        We believe that the only way a man is saved is by believing in the Gospel. And that same gospel has the power to transform a man. We take Jesus’ instruction to go into the world and make disciples of every nation seriously. So, we are dedicated to raising men who win souls, do the word, and demonstrate the power of God.
                    </div>
                    
                    <div class="mt-10"> 
                        We know from God’s word that every believer has received the ministry of reconciliation, and has been called to demonstrate the power of God. We are committed to raising men who know who they are in Christ and take their place as God’s answer to a world in need.
                    </div>
                    
                </div>
            </div>
        </div>

        <BecomeOurFamily />

        <BottomLinks />
    </div>
</template>

<script setup>
import Hero from '../components/What_we_believe/Hero.vue';
import BecomeOurFamily from '../components/BecomeOurFamily.vue'
import BottomLinks from '../components/What_we_believe/BottomLinks.vue';
</script>

<style scoped>

</style>